module.exports = __webpack_public_path__ + "img/7.9c85c60b.png";